import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.895 6h4.21c.166 0 .329.052.47.151.14.1.253.242.324.41a1.3 1.3 0 0 1-.13 1.239l-2.104 2.86a.9.9 0 0 1-.3.25.8.8 0 0 1-.73 0 .9.9 0 0 1-.3-.25L5.231 7.8a1.3 1.3 0 0 1-.13-1.239.96.96 0 0 1 .325-.41.8.8 0 0 1 .47-.151", fill: "#C5C9CB" }));
const ForwardRef = forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
